module.exports = __webpack_public_path__ + "6cde640f0189caa8287c7428c0de9b9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/picture/Stanley.jpg
// module id = 469
// module chunks = 0